export enum AppSort {
  Asc = 'asc',
  Desc = 'desc',
}
